import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    
    <p class="mb-3">
      Mi konas du mirindajn historiojn pri amo. Amo potencega, ĉionvenkanta, senlima, senkompara. Unu el tiuj historioj okazis en Ĉinio, alia en Skotlando. Jen ili.
    </p>
    
    <p class="mb-3">
      La imperiestro Xuanzong (Hsuan-tsung, 685-762) ekamis la junulinon Ĝang Gui-fei (Jan Guj-fej). Pro ŝi li forlasis ĉiujn ŝtatregajn aferojn, kaj la lando komencis disfali: ĝin invadis diversaj najbaraj triboj, kaj ankaŭ ene de ĝi ribelis kamparanoj kontraŭ sensatigeblaj lokaj gravuloj, kiujn jam ne bridis forta unuiga mano. 
    </p>
    
    <p class="mb-3">
      Sed kiel gravas ĉio tio, se apudas juna belulino Ĝang Gui-fei! La amo ja pli gravas ol ĉio en la vivo! La granda imperio estis fordonita kontraŭ amo, kaj neniu en la tuta mondo pagis tian prezon pro la amo. Nenio kompareblas kun tia grandega amo de l’ imperiestro   Xuanzong!
    </p>
    
    <p class="mb-3">
      Sed militestro An Lu-ŝan komencis ribelon kaj facile konkeris la duonruinigitan landon. La imperiestro kaj Ĝang Gui-fei provis fuĝi, sed estis kaptitaj survoje. La militistoj promesis konservi la sanktan vivon de l’ imperiestro, sed postulis la morton de Ĝang Gui-fei. Kaj la imperiestro Xuanzong mem ligis la silkan ŝnuron ĉirkaŭ la kolo de sia kunulino. 
    </p>
    
    <p class="mb-3">
      Kiom valoras ŝia vivaĉo kontraŭ la ĉielegala persono de la imperiestro? Oni povas oferi grandegan landon kun milionoj da vivoj; sed vivoj fremdaj ja! Sed oferi SIAN PROPRAN  vivon pro iu alia?!? Kia amo, se temas pri propra mizera vivo?! Pereu kaj belulino, kaj la amo, se por ili oni devas pagi per propra sekureco… 
    </p>
    
    <p class="mb-5">
      Jen tia estis la granda amo de l’ imperiestro Xuanzong. 
    </p>

    <p class="mb-3">
      Junulino Ĝenet ekamis kavaliron Temlin, kiun la reĝino de elfoj transformis en elfon. Sed li volis reveni al homa mondo kaj rehavi homan animon, sed ne servi al reĝino de elfoj. Li petis Ĝenet savi lin. 
    </p>
    
    <p class="mb-3">
      La reĝino konsentis liberigi lin, sed ĉe unu kondiĉo: ke Ĝenet ĉirkaŭbraku kaj tenu  ĉe sia sino kaj ne ellasu lin, kiajn ajn aspektojn li ekhavu. Per sia magia forto la reĝino de elfoj faris el li jen abomenan saŭron, jen serpenton, vipantan per veneno al koro, jen fanditan metalon, kiu bruligis la vizaĝon kaj manojn de Ĝenet. Sed ŝi ne forlasis lin, kaj li denove fariĝis homo. 
    </p>
    
    <p class="mb-3">
      Li edziĝis al Ĝenet; sed post iom da tempo li eksentis enuon apud maljunuĝinta, kripligita per teruraj brulvundoj Ĝenet. Li rememoris karesojn kaj ĉiopovon de la reĝino de elfoj, kaj revenis al ŝi.
    </p>
    
    <p class="mb-5">
      Sed Ĝenet… Nu kio Ĝenet? Kiu bezonas, kiu amus ŝin, se ŝi jam estas maljuna kaj malbela? Kaj kiu bezonus ŝian grandegan amon, kiu ŝanĝis la vivojn de du homoj, sed jam dufoje pereigis ŝin? 
    </p>

    <p class="mb-3">
      Jen du historioj pri amo el du diversaj partoj de la mondo. Amo de viro kaj amo de virino. 
    </p>
    `
  )
}

const itemName = {
  esp: 'Du elstaraj historioj pri amo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['Nf8_tjIyHow'],
    itemAuthor: author.esp,
  }
}

export default item; 